






































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import ValidatedPasswordInput from '../../components/NewWallet/ValidatedPassword.vue';
import NewWallet from '~/components/NewWallet/NewWallet.vue';
import recoverWalletMutation from '../../mutations/recoverWallet.gql';
import { setTimeout } from 'timers';
import { Mutation, State } from 'vuex-class';
import AuthQuery from '~/mixins/AuthQuery';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { isTwoFaError } from '~/utils/errorCodes';
import { TwoFaCheckpoint } from '~/types/two-fa-checkpoints';
import { IUser } from '~/store/profile/types';

@Component({
  components: { ValidatedPasswordInput, TwoFactorAuthInputPrompt, NewWallet },
})
export default class GyriPassphrase extends Mixins(AuthQuery) {
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;

  @Mutation toggleSuccessSnackbar!: (payload?: boolean) => void;
  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;
  @Mutation updateSnackbarSuccessText!: (args: any) => void;

  @Prop(Function)
  closeDialog!: () => void;

  newPassInput = '';
  mnemonic = '';
  valid = false;
  newPassValid = false;

  inFlight = false;

  get btnDisabled() {
    return !this.valid || !this.newPassValid;
  }

  passRule(value: string) {
    const strongPasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,()-_+=`~\][\{}\\|<>?.])(?=.{8,})/;
    const isValidPass = strongPasswordPattern.test(value);
    return (
      isValidPass ||
      (this.$t('components.settings.changePassword.passwordInvalid') as string)
    );
  }

  mnemonicRule(value: string) {
    const mnemonicValid = value.split(' ').length === 12;
    return (
      mnemonicValid ||
      (this.$t(
        'components.settings.changePassword.invalidRecoveryPhrase',
      ) as string)
    );
  }

  handleNewPassValid({
    valid,
    password,
  }: {
    valid: boolean;
    password: string;
  }) {
    this.newPassValid = valid;
    this.newPassInput = password;
  }

  async handleSubmit() {
    if (!this.valid || !this.newPassValid) return;
    this.inFlight = true;

    await this.doAuthQuery(async totpToken => {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: recoverWalletMutation,
          variables: {
            mnemonic: this.mnemonic,
            newPassword: this.newPassInput,
            totpToken,
          },
        });

        if (data && data.recoverWallet) {
          const { success, message } = data.recoverWallet;

          if (success) {
            this.updateSnackbarSuccessText(
              this.$t(
                'components.settings.changePassword.passwordResetMsg',
              ) as string,
            );
            this.toggleSuccessSnackbar();
            this.mnemonic = '';
            setTimeout(() => {
              this.closeDialog();
            }, 1000);
          } else {
            this.updateSnackbarErrorText(message);
            this.toggleErrorSnackbar();
          }
        }
      } catch (error) {
        if (isTwoFaError(error)) {
          throw error;
        }

        let message = '';
        if (error.message.includes('Invalid recovery phrase')) {
          message = this.$t(
            'components.settings.changePassword.invalidRecoveryPhrase',
          ) as string;
        } else {
          this.$sentry.captureException(error);
          message = this.$t(
            'components.settings.changePassword.passwordChangeError',
          ) as string;
        }

        console.warn(error);

        this.updateSnackbarErrorText(message);
        this.toggleErrorSnackbar();
      }
    }, TwoFaCheckpoint.transferCodeRecovery);

    this.inFlight = false;
  }
}
